import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import LinkIcon from '@mui/icons-material/Link';

export type PaymentMethod = 'qr' | 'cash' | 'payment_link' | 'other' | null | undefined;

type Props = {
    method: PaymentMethod;
    color?: string;
};

const PaymentMethodIcon: FC<Props> = ({ method, color }) => {
    const wrapperSx = {
        width: 24,
        height: 24,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    } as const;

    if (method === 'cash') {
        return (
            <Box sx={wrapperSx}>
                <MonetizationOnOutlinedIcon
                    sx={{
                        fontSize: 20,
                        color: color || '#44D600'
                    }}
                />
            </Box>
        );
    }

    if (method === 'qr') {
        return (
            <Box sx={wrapperSx}>
                <QrCode2Icon
                    sx={{
                        fontSize: 18,
                        color: color || '#1A75FF'
                    }}
                />
            </Box>
        );
    }

    if (method === 'payment_link') {
        return (
            <Box sx={wrapperSx}>
                <LinkIcon
                    sx={{
                        fontSize: 20,
                        color: color || '#FFA31A'
                    }}
                />
            </Box>
        );
    }

    if (method === 'other') {
        return (
            <Box sx={wrapperSx}>
                <CardTravelIcon
                    sx={{
                        fontSize: 20,
                        color: color || '#8B5CF6'
                    }}
                />
            </Box>
        );
    }

    // null, undefined o valor desconocido
    return (
        <Box sx={wrapperSx}>
            <CardTravelIcon
                sx={{
                    fontSize: 20,
                    color: color || '#4ECAFF'
                }}
            />
        </Box>
    );
};

export default PaymentMethodIcon;
